import gsap from 'gsap'
import CustomEase from 'gsap/CustomEase'

gsap.registerPlugin(CustomEase)

export default class Menu {
    constructor() {
        this.header = document.querySelector('header')
        this.headerContainer = document.querySelector('.header-container')
        this.menuButton = document.querySelector('.header-menu')
        this.dropdown = document.querySelector('.header-dropdown')
        
        if (!this.menuButton || !this.dropdown || !this.header) return
        
        this.tl = gsap.timeline({ paused: true })
        this.isOpen = false
        
        this.setupAnimation()
        this.addEventListeners()
        this.initScrollDetection()
    }

    setupAnimation() {
        gsap.set(this.dropdown, { display: 'none', autoAlpha: 0 })
        gsap.set('.header-dropdown-content', { scaleY: 0, transformOrigin: 'top' })
        gsap.set('.header-dropdown-footer', { scaleY: 0, transformOrigin: 'top' })
        gsap.set('.header-dropdown-content-links a', { y: 20, autoAlpha: 0 })
        gsap.set('.header-dropdown-content-areas-item', { y: 30, autoAlpha: 0 })
        gsap.set('.header-dropdown-content-areas-mobile-item', { y: 30, autoAlpha: 0 })
        gsap.set('.header-dropdown-footer > *', { y: 20, autoAlpha: 0 })

        this.tl.set(this.dropdown, { display: 'block' })
        
        this.tl.to(this.dropdown, {
            duration: .1,
            autoAlpha: 1,
            ease: CustomEase.create("out", "0.125, 0.425, 0.270, 1.000")
        })

        this.tl.to('.header-dropdown-content', {
            duration: .6,
            scaleY: 1,
            stagger: 0.2,
            ease: CustomEase.create("out", "0.125, 0.425, 0.270, 1.000")
        }, '-=0.05')

        this.tl.to('.header-dropdown-footer', {
            duration: .6,
            scaleY: 1,
            stagger: 0.2,
            ease: CustomEase.create("out", "0.125, 0.425, 0.270, 1.000")
        }, '-=0.2')

        this.tl.to('.header-dropdown-content-links a', {
            duration: 0.5,
            y: 0,
            autoAlpha: 1,
            stagger: 0.05,
            ease: CustomEase.create("out", "0.125, 0.425, 0.270, 1.000")
        }, '-=0.6')

        this.tl.to('.header-dropdown-content-areas-item, .header-dropdown-content-areas-mobile-item', {
            duration: 0.5,
            y: 0,
            autoAlpha: 1,
            stagger: 0.1,
            ease: CustomEase.create("out", "0.125, 0.425, 0.270, 1.000")
        }, '-=0.6')

        this.tl.to('.header-dropdown-footer > *', {
            duration: 0.4,
            y: 0,
            autoAlpha: 1,
            stagger: 0.05,
            ease: CustomEase.create("out", "0.125, 0.425, 0.270, 1.000")
        }, '-=0.4')
    }

    addEventListeners() {
        this.menuButton.addEventListener('click', (e) => {
            e.preventDefault()
            this.toggle()
        })

        const dropdownLinks = document.querySelectorAll('.header-dropdown-content-links a')
        dropdownLinks.forEach(link => {
            link.addEventListener('click', () => {
                if (this.isOpen) {
                    this.close()
                }
            })
        })

        const areaItems = document.querySelectorAll('.header-dropdown-content-areas-item')
        areaItems.forEach(item => {
            item.addEventListener('click', () => {
                if (this.isOpen) {
                    this.close()
                }
            })
        })
    }

    toggle() {
        if (this.isOpen) {
            this.close()
        } else {
            this.open()
        }
    }

    open() {
        this.isOpen = true
        this.menuButton.classList.add('is-active')
        this.header.classList.add('is-open')
        this.tl.play()
    }

    close() {
        this.isOpen = false
        this.menuButton.classList.remove('is-active')
        this.header.classList.remove('is-open')
        gsap.to(this.dropdown, {
            duration: 0.3,
            autoAlpha: 0,
            ease: 'power2.in',
            onComplete: () => {
                this.tl.pause(0)
                gsap.set(this.dropdown, { display: 'none' })
            }
        })
    }

    initScrollDetection() {
        if (!this.headerContainer) return
        
        const scrollThreshold = 50
        let lastScrollY = window.scrollY
        let ticking = false
        
        window.addEventListener('scroll', () => {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    const currentScrollY = window.scrollY
                    
                    // Add/remove background on scroll
                    if (currentScrollY > scrollThreshold) {
                        this.headerContainer.classList.add('is-scroll')
                    } else {
                        this.headerContainer.classList.remove('is-scroll')
                    }
                    
                    // Hide/show header based on scroll direction
                    if (currentScrollY > lastScrollY && currentScrollY > scrollThreshold) {
                        // Scrolling down - hide header
                        this.headerContainer.classList.add('is-hidden')
                    } else {
                        // Scrolling up - show header
                        this.headerContainer.classList.remove('is-hidden')
                    }
                    
                    lastScrollY = currentScrollY
                    ticking = false
                })
                ticking = true
            }
        })
    }
}